import React from "react";
import MainImage from "../../../assets/Braiders/JaJas-African-Hair-Braiding-Arena-Stg_195-scaled.jpg";
import Footer from "../../../components/Footer";
import NavLite from "../../../components/NavLite";
import StarterBraider from "../../../components/Braiders/StarterBraider";
import GrowthBraider from "../../../components/Braiders/GrowthBraider";
import VIPBraider from "../../../components/Braiders/VIPBraider";
import Brandlist from "../../../components/Brandlist";
import PastWordBraids from "../../../components/Braiders/PastWordBraids";
import TestimonialsSection from "../../../components/Braiders/TestimonialsSection";
import BraiderFunnel from "../../../components/Braiders/BraiderFunnel";

function NewOrleansBraiderPage() {
  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F6F3F1]">
      <title>
        Hair Braider Website Design in New Orleans | Woaom Web Design
      </title>
      <meta
        name="description"
        content="Custom websites for hair braiders in New Orleans with booking, SEO, and marketing systems. Look professional, attract more clients, and grow your braiding business in NOLA."
      />
      <meta
        name="keywords"
        content="Hair Braiding Website Design in New Orleans, Best Hair Braiding Website Templates New Orleans, Custom Hair Braider Websites New Orleans, Professional Hair-Braiding Portfolio Website New Orleans, Hair Braiding Website with Booking in New Orleans, Affordable Hair Braiding Site Design for New Orleans Stylists, SEO for Hair Braiders – New Orleans Website Services, Mobile-Friendly Hair-Braiding Websites in New Orleans, Local Hair Braiding Business Website New Orleans, Top Hair Braiding Website Examples in New Orleans, Hair Braiding Salon Website New Orleans, Hair Braids Portfolio Website – New Orleans, Box Braids Website Design in New Orleans, Knotless Braids Site Design New Orleans, African Hair Braiding Website New Orleans, Hair Braid Booking Website Design New Orleans, Hair Braiding Service Website Optimization – New Orleans, Responsive Hair Braiding Website New Orleans, Hair Braiding Website Builder for New Orleans Braiders, Get Hair Braiding Clients via Website in New Orleans"
      />

      {/* Hero Section */}
      <section className="bg-[#F6F3F1]">
        <div
          className="relative h-auto bg-cover bg-center object-top"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          {/* Overlay */}
          <NavLite />

          {/* Hero copy overlay */}
          <div className="mx-auto w-full max-w-7xl px-5 md:px-10 md:py-40 py-56">
            <div className="max-w-3xl bg-white/80 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-lg">
              <p className="uppercase text-xs tracking-widest text-black mb-2">
                for New Orleans braiders
              </p>
              <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 leading-tight">
                New Orleans braiders — let your website jazz up your bookings.
              </h1>
              <p className="mt-3 text-gray-700 md:text-lg">
                Get a website that attracts clients, automates bookings, and
                helps your braiding brand shine across New Orleans.
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <a href="#packages">
                  <button className="bg-[#C18343] text-white uppercase tracking-widest px-6 py-3 text-sm hover:bg-[#a76e33] transition-colors rounded-lg">
                    View Packages →
                  </button>
                </a>
                <a
                  href="https://cal.com/woaomwebdesign/15min "
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-white text-gray-900 border border-gray-300 rounded-lg px-6 py-3 text-sm hover:bg-gray-50 transition-colors">
                    Free 15-min Consult
                  </button>
                </a>
              </div>
              <p className="mt-4 text-sm text-gray-600">
                Trusted by braiders in New Orleans, Baton Rouge, and beyond.
              </p>
            </div>
          </div>
        </div>

        {/* Intro */}
        <div className="mx-auto max-w-7xl px-5 py-10 md:px-10 text-center">
          <p className="uppercase text-sm text-[#c6884a] tracking-widest mb-2">
            Best Websites for New Orleans Braiders
          </p>
          <h2 className="mb-4 text-3xl md:text-5xl text-black">
            Websites That Help New Orleans Braiders Book Clients & Grow
          </h2>
          <p className="mx-auto mb-5 max-w-3xl text-sm text-gray-600 sm:text-xl">
            At Woaom Web Design, we design websites and marketing systems that
            help New Orleans braiders look professional, attract more clients,
            and grow their businesses with confidence.
          </p>
        </div>

        {/* Packages */}
        <div id="packages" className="scroll-mt-24">
          <StarterBraider />
          <GrowthBraider />
          <VIPBraider />
        </div>

        {/* Why Choose Section */}
        <div className="mx-auto max-w-5xl px-5 py-10 text-center">
          <h3 className="text-3xl md:text-4xl text-gray-900 mb-6">
            Why New Orleans Braiders Choose Woaom Web Design
          </h3>
          <ul className="text-gray-700 space-y-3 text-lg">
            <li>✨ Beauty-focused websites made for braiders</li>
            <li>✨ Booking, payments, reviews, and SEO setup included</li>
            <li>✨ Premium design that reflects your New Orleans style</li>
            <li>✨ Support from side-hustle to fully booked salon</li>
          </ul>
        </div>

        {/* Credibility: As Seen On / Brand list */}
        <Brandlist />

        {/* Call To Action */}
        <div className="text-center py-12">
          <h3 className="text-3xl md:text-4xl mb-4 text-gray-900">
            Ready to Grow Your Braiding Business in New Orleans?
          </h3>
          <p className="text-gray-700 mb-6">
            Don’t let clients pass you by — let’s build the website and
            marketing system that makes your New Orleans braiding business stand
            out.
          </p>
          <a href="/contact">
            <button className="bg-[#C18343] text-white uppercase tracking-widest px-8 py-4 text-sm hover:bg-[#a76e33] transition-colors rounded-lg">
              Book Your Package Today →
            </button>
          </a>
          <p className="text-xs text-gray-600 mt-3">
            Limited spots available monthly • 100% satisfaction guarantee
          </p>
        </div>

        <PastWordBraids />
        <TestimonialsSection />
        <BraiderFunnel />
        <Footer />
      </section>
    </main>
  );
}

export default NewOrleansBraiderPage;
